module.exports = __webpack_public_path__ + "static/media/sophisticated-thumbnail1.37a82e44.png";